// Blue palette

// https://color-hex.org/color/0f1f2c

// #0f1f2c - darkest
// #273541 - graybluer
// #3F4B56 - 800
// #57626B
// #6F7880 - 700
// #878F95 - 600
// #9FA5AA - smokewhite
// #B7BBBF - primaryColor
// #CFD2D4
// #E7E8E9
// #FFFFFE - lightest

export const main = {
  colors: {
    primaryColor: '#B7BBBF',
    highlight: '#9ee04e',
    highlightActive: '#7eb33e',
    highlightBlue: '#426bbf',
    white: '#FFF',
    greyWhite: '#CFD2D4',
    smokeWhite: '#9FA5AA',
    gray600: '#878F95',
    gray700: '#6F7880',
    gray800: '#3F4B56',
    black: '#101315',
    grayBlackShadow: '#333',
    grayBluer: '#273541',
    grayBluer2: '#202c37',
    ecgBackground: '#fafafe',
    borderRed: '#ad0c0c',
    borderGreen: '#45963f',
    borderBlue: '#3a65c4',
    borderYellow: '#b2bc00',
  },
  layout: {
    direction: 'row',
  },
  font: {
    size: {
      ultrasmaller: '0.9rem',
      smaller: '1rem',
      small: '1.1rem',
      medium: '1.2rem',
      semilarge: '1.3rem',
      large: '1.4rem',
      larger: '1.5rem',
      huge: '1.8rem',
    },
    weight: {
      ultralight: 100,
      light: 200,
      medium: 400,
      semibold: 500,
      bold: 600,
    },
  },
  sizes: {
    mobile: '640px',
    tablet: '1024px',
    desktop: '1280px',
  },
};
